export default function getExtensionIcon(ext) {
    switch(ext) {
        case 'mp4': return 'far fa-file-video'
        break

        case 'pdf': return 'far fa-file-pdf'
        break

        case 'png':
        case 'jpg':
        case 'gif': return 'far fa-file-image'
        break

        case 'zip':
        case 'rar':
        case 'gzip':
        case 'tz': return 'far fa-file-archive'
        break

        case 'xlsx':
        case 'xls': return 'far fa-file-excel'
        break

        case 'docx':
        case 'doc': return 'far fa-file-word'
        break

        case 'pptx':
        case 'ppt': return 'far fa-file-powerpoint'

        default: return 'far fa-file'
        break
    }
}